import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setPage } from '../../redux/appSlice';
import { Button, Icon, Message, Table } from 'semantic-ui-react';
import StateAidLetter from '../StateAidLetters/StateAidLetter';
import useReactToPrint from 'react-to-print';


const useTitle = (title) => {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        }
    })
}

const StateAidLetterService = () => {
    const projectState = useSelector(state => state.project);
    const dispatch = useDispatch();
    const componentRef = useRef();

    const handlePrint = () => {
        console.log('print');
    };
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current
    // });
    useTitle(projectState.project.customIdentifier + ' ' + projectState.project.acronym+'_StateAidsLetters');

    return ( 
        <div>
            <div className='menu'>
                <Button.Group>
                    <Button icon onClick={() => dispatch(setPage('Projects'))} color='blue' labelPosition='left'>
                        <Icon name='arrow left' />
                        Back
                    </Button>
                    <Button.Or />
                    <Button icon onClick={handlePrint} color='blue' labelPosition='right'>
                        <Icon name='print' />
                        Print
                    </Button>
                </Button.Group>
            </div>
            <StateAidLetter ref={componentRef} projectState={projectState} />
        </div>
    );


}

export default StateAidLetterService;
